import { render, staticRenderFns } from "./SDialogClientSaleComp.vue?vue&type=template&id=b3d10d68&"
import script from "./SDialogClientSaleComp.vue?vue&type=script&lang=js&"
export * from "./SDialogClientSaleComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports